<template>
  <div class="page page--step4">
    <div class="container">
      <div class="panel">
        <div class="panel-header">
          <h1>Tell us more about your symptoms</h1>
        </div>

        <div class="panel-body panel-body-flush">
          <Questions
            ref="questions"
            :section="3"
            previous-route="survey.step-3"
            :next-route="goToNextSection"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Questions from "@/components/Survey/Questions"
import {buildTriagePayload} from "@/store/survey"

export default {
  components: {
    Questions,
  },

  mounted() {
    this.goToStartIfNecessary();
    this.setCurrentStep(4);
    this.scrollToTop();
  },

  methods: {
    goToNextSection() {
      const payload = buildTriagePayload(this.$store.state.survey);

      if (payload.outcome === "appointment") {
        this.$router.push(this.routes.appointmentNeeded);
      } else {
        this.$router.push(this.routes.appointmentNotNeeded);
      }
    },
  },
};
</script>
